import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { IEffect } from '../../../../../../shared/modules/dynamic-effects/effect.interface';
import {
  LOAD_ADDRESS,
  LoadPointOfDeliveryAddress,
  LoadPointOfDeliveryAddressComplete,
  LoadPointOfDeliveryAddressFail,
} from '../../../actions/point-of-delivery-actions/point-of-delivery.actions';
import {
  IAddressResponse,
  IRequestedAddressResponse,
} from '@cemex-core/cmx-api/models/addresses-req-management/addresses-response';
import { AddressesService, OpportunityService, SHIPMENT_LOCATION_TYPE_ID } from '@cemex-core/cmx-api';
import { OpportunityResponse } from '@cemex-core/cmx-api/models/opportunity/opportunity-response';

@Injectable()
export class PointOfDeliveryLoadAddressEffects implements IEffect {
  PointOfDeliveryLoadAddress$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_ADDRESS),
      switchMap((action: LoadPointOfDeliveryAddress) => {
        if (
          action.payload.shipmentLocationType &&
          action.payload.shipmentLocationType.shipmentLocationTypeId ===
            SHIPMENT_LOCATION_TYPE_ID.POINT_OF_DELIVERY_REQUEST
        ) {
          return this.opportunityService.getOpportunity(action.payload.shipmentLocationId).pipe(
            switchMap((opportunity: OpportunityResponse) =>
              this.addressesService.getAddressRequest(opportunity.addressRequest.addressRequestId),
            ),
            map((address: IRequestedAddressResponse) => new LoadPointOfDeliveryAddressComplete(address)),
            catchError((error) => of(new LoadPointOfDeliveryAddressFail(error))),
          );
        }

        return this.addressesService.getAddress(action.payload.address.addressId).pipe(
          map((addressResponse: IAddressResponse) => {
            return new LoadPointOfDeliveryAddressComplete(addressResponse);
          }),
          catchError((error) => of(new LoadPointOfDeliveryAddressFail(error))),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private addressesService: AddressesService,
    private opportunityService: OpportunityService,
  ) {}
}
